/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { CSSProperties, ReactNode } from "react";
import dayjs from "dayjs";
import { ExtendedTooltip, Text } from "@nordcloud/gnui";
import { dateFormat } from "~/constants/dateFormats";

type Props = {
  startTime: string;
  scheduleTimezone: string;
  children: ReactNode;
  placement?: "top" | "bottom" | "left" | "right";
  position?: "start" | "center" | "end";
  style?: CSSProperties;
};

export function NextPatchingActionTooltip({
  startTime,
  scheduleTimezone,
  children,
  placement = "bottom",
  position = "center",
  style,
}: Props) {
  const formattedDate = dayjs(startTime).format(
    dateFormat.dayMonthYearHourMinute
  );
  const utcOffset = dayjs(startTime).tz(scheduleTimezone).format("Z");

  return (
    <ExtendedTooltip
      style={style}
      caption={
        <>
          <Text size={"sm"} css={{ margin: 0 }}>
            Plan Time: {formattedDate}
          </Text>
          <Text size={"xs"} css={{ margin: 0 }}>
            Timezone: UTC {utcOffset} | {scheduleTimezone}
          </Text>
        </>
      }
      placement={placement}
      position={position}
    >
      {children}
    </ExtendedTooltip>
  );
}
